@if (isLoading) {
  <div class="spinner-container">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
<app-claim-information-form (updatedClaimInformation)="setFormValue($event)"
  (validForSave)="isValidForSave($event)"
  (validForSend)="isValidForSend($event)"
  (isTouched)="isTouched($event)"
  (isLoading)="formIsLoading($event)"
  (claimAttachments)="setAttachmentsValue($event)"
[hasTitle]="false"></app-claim-information-form>